import summaryForm from './summary-form.json';
import common from './common.json';
import form from './form.json';
import texts from './texts.json';
import languages from './languages.json';
import login from './login.json';
import mainMenu from './main-menu.json';
import documentation from './documentation.json';
import userProfile from './user-profile.json';
import register from './register.json';
import formPage from './form-page.json';
import payments from './payments.json';
import legal from './legal.json';
import dashboard from './dashboard.json';
import PDDForm from './PDDForm.json';
const es = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, languages), texts), form), common), summaryForm), login), mainMenu), documentation), userProfile), register), formPage), payments), legal), dashboard), PDDForm);
export default es;
